import { jsPDF } from 'jspdf';

import { includeLeftZero } from './includeLeftZero';
import { formatDate } from './formatDate';

let feSaudeLogo = new Image();
feSaudeLogo.src = '../assets/img/fesaude-logo.png';
feSaudeLogo.alt = 'FeSaúde Logo';

const pdfBriefing = data => { 
  const doc = new jsPDF('p', 'mm', 'a4');

  doc.setProperties({
    title: `Chamado ${includeLeftZero(data.numeroChamado)}`
  });
  
  const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.text(
    'SisGeD - Sistema de Gestão de Demandas',
    pageWidth / 2,
    15,
    { align: 'center' }
  );

  doc.setFontSize(15);
  doc.text(
    `Solicitação ${includeLeftZero(data.numeroChamado)} - Status: ${data.status}`,
    pageWidth / 2,
    25,
    { align: 'center' }
  );

  doc.addImage(feSaudeLogo, 'PNG', 15, 10, 16, 17);

  doc.setFontSize(10);
  doc.text(
    `e-mail: ${data.email}`,
    15,
    40,
    { align: 'left' }
  );

  doc.text(
    `Nome do Solicitante: ${data.nome}`,
    15,
    45,
    { align: 'left' }
  );

  doc.text(
    `Telefone: ${data.telefone}`,
    15,
    50,
    { align: 'left' }
  );

  doc.text(
    `Unidade: ${data.unidade}`,
    15,
    55,
    { align: 'left' }
  );

  doc.text(
    `Categoria: ${data.categoria}`,
    15,
    60,
    { align: 'left' }
  );

  doc.text(
    `Subcategoria: ${data.subcategoria}`,
    15,
    65,
    { align: 'left' }
  );

  doc.text(
    `SLA: ${data.sla} - Data Inicial: ${formatDate(data.createdAt)} - Data Final: ${data.finalAt ? formatDate(data.finalAt) : ''}`,
    15,
    70,
    { align: 'left' }
  );

  const leftMargin = 15;
  const rightMargin = 15;
  const pageInMm = 210;
  const linesObs = data.obs;

  if (data?.obs?.length > 0) {
    doc.text(
      'Observações:',
      15,
      75,
      { align: 'left' }
    );
  
    const obs = doc.splitTextToSize(linesObs, (pageInMm - leftMargin - rightMargin));

    doc.text(leftMargin, 80, obs);
  } else {
    doc.text(
      'Observações:',
      15,
      75,
      { align: 'left' }
    );
  }

  const linesBriefingPorque = data?.briefing?.briefingPorque;
  const briefingPorque = doc.splitTextToSize(linesBriefingPorque, (pageInMm - leftMargin - rightMargin));
  
  const linesBriefingMedidas = data?.briefing?.briefingMedidas;
  const briefingMedidas = doc.splitTextToSize(linesBriefingMedidas, (pageInMm - leftMargin - rightMargin));

  const linesBriefingOnde = data?.briefing?.briefingOnde;
  const briefingOnde = doc.splitTextToSize(linesBriefingOnde, (pageInMm - leftMargin - rightMargin));

  const linesBriefingDetalhe = data?.briefing?.briefingDetalhe;
  const briefingDetalhe = doc.splitTextToSize(linesBriefingDetalhe, (pageInMm - leftMargin - rightMargin));

  doc.text(
    'O que precisamos fazer? Por que você está fazendo esse pedido?',
    15,
    105,
    { align: 'left' }
  );

  doc.text(leftMargin, 110, briefingPorque);

  doc.text(
    'Quais peças devem ser desenvolvidas/criadas? Quais as medidas (largura X altura)?',
    15,
    135,
    { align: 'left' }
  );

  doc.text(leftMargin, 140, briefingMedidas);

  doc.text(
    'Onde serão veiculadas/expostas? (Redes sociais, portal, impressos, eventos etc.)',
    15,
    165,
    { align: 'left' }
  );

  doc.text(leftMargin, 170, briefingOnde);

  doc.text(
    'Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção.',
    15,
    195,
    { align: 'left' }
  );

  doc.text(
    formatDate(data?.briefing?.briefingPrazo),
    15,
    200,
    { align: 'left' }
  );

  doc.text(
    'Tem mais algum detalhe? Deixe aqui o seu comentário para inspirar a nossa equipe.',
    15,
    210,
    { align: 'left' }
  );

  doc.text(leftMargin, 215, briefingDetalhe);

  if (data?.briefing?.briefingArquivos.length > 0) {
    doc.text(
      'Tem algum arquivo (foto, texto ou logo) que precisamos receber? Envie anexo. (Máximo de 5 anexos com 5MB cada)',
      15,
      240,
      { align: 'left' }
    );

    doc.text(
      'Arquivos suportados: .pdf, .png, .gif, .jpg, .jpeg, .svg, .txt, .doc, .docx, .xls, .xlsx',
      15,
      245,
      { align: 'left' }
    );

    data?.briefing?.briefingArquivos.forEach((item, i) => {
      doc.text(
        item.originalName,
        15,
        255 + (i * 5),
        { align: 'left' }
      );
    });
  }

  window.open(URL.createObjectURL(doc.output(
    'blob',
    {
      filename: `chamado${includeLeftZero(data.numeroChamado)}`
    }
  )));
};

export default pdfBriefing;
